import { provideHttpClient, withFetch } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { IAC_APP_ROUTES } from './app.routes';

export const IAC_APP_CONFIG: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(IAC_APP_ROUTES),
    provideHttpClient(withFetch()),
  ],
};
